import React from "react";

const CertificateIcon: React.FC<React.SVGAttributes<NonNullable<unknown>>> = (
  props,
) => (
  <svg
    fill="none"
    {...props}
    viewBox="0 0 37 37"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5078 30.7494C21.4072 30.7494 23.7577 28.3989 23.7577 25.4995C23.7577 22.6 21.4072 20.2495 18.5078 20.2495C15.6083 20.2495 13.2578 22.6 13.2578 25.4995C13.2578 28.3989 15.6083 30.7494 18.5078 30.7494Z"
      strokeWidth="2"
    />
    <path
      d="M13.4495 25.4297L11.6295 27.2497L9.04305 29.7294C8.47606 30.2736 8.19256 30.5449 8.09456 30.7759C7.98437 31.0216 7.96994 31.2995 8.05412 31.5553C8.13829 31.8111 8.31499 32.0262 8.54956 32.1584C8.76305 32.2791 9.1498 32.3159 9.91979 32.3929C10.3538 32.4349 10.5725 32.4559 10.7545 32.5206C10.9525 32.589 11.1332 32.6995 11.2843 32.8445C11.4353 32.9895 11.5531 33.1656 11.6295 33.3606C11.6978 33.5356 11.7205 33.7439 11.7643 34.1621C11.843 34.9006 11.8833 35.2698 12.0093 35.4746C12.2963 35.9418 12.9035 36.1256 13.4513 35.9121C13.691 35.8158 13.9745 35.5446 14.5415 35.0021L18.5017 31.2046L22.4619 35.0021C23.0289 35.5446 23.3124 35.8158 23.5521 35.9121C24.0999 36.1256 24.7071 35.9418 24.9941 35.4746C25.1201 35.2698 25.1604 34.9006 25.2391 34.1621C25.2829 33.7439 25.3056 33.5356 25.3739 33.3606C25.4504 33.1657 25.5682 32.9897 25.7193 32.8446C25.8703 32.6996 26.051 32.5891 26.2489 32.5206C26.4326 32.4559 26.6496 32.4349 27.0836 32.3929C27.8536 32.3176 28.2404 32.2791 28.4538 32.1584C28.6884 32.0262 28.8651 31.8111 28.9493 31.5553C29.0335 31.2995 29.019 31.0216 28.9088 30.7759C28.8108 30.5449 28.5273 30.2736 27.9604 29.7294L25.3721 27.2497L23.7516 25.6274"
      strokeWidth="2"
    />
    <path
      d="M27.8097 28.9927C31.2607 28.956 33.1857 28.739 34.4614 27.4615C35.9996 25.925 35.9996 23.4488 35.9996 18.4998V11.4999C35.9996 6.55094 35.9996 4.07472 34.4614 2.53823C32.9249 1 30.4487 1 25.4997 1H11.4999C6.55094 1 4.07472 1 2.53823 2.53823C1 4.07472 1 6.55094 1 11.4999V18.4998C1 23.4488 1 25.925 2.53823 27.4615C3.88222 28.8072 5.9437 28.9752 9.74991 28.9962"
      strokeWidth="2"
    />
    <path
      d="M13.25 8H23.7499M9.75 14.1249H27.2498"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

export default CertificateIcon;
